/**
 * HPQ Dynamic Announcement Bar — replaces static text with shipping progress.
 *
 * Targets Stiletto's announcement-bar__item-inner elements.
 *
 * States:
 * 1. Cart empty:     "FREE SHIPPING ON ORDERS $59+"
 * 2. Cart has items: <progress-bar> $XX.XX to FREE SHIPPING
 * 3. Free threshold: ✓ FREE SHIPPING EARNED
 */
(function () {
  'use strict';

  var THRESHOLD = (window.hpqFreeShip && window.hpqFreeShip.threshold) || 5900;
  var THRESHOLD_DOLLARS = '$' + Math.floor(THRESHOLD / 100);
  var targets = [];

  // Free-ship state (threshold + coupon-adjusted effective total + status) is owned by
  // hpq-free-ship.js and shared with the cart-page bar + drawer bar, so this nav bar can never
  // disagree with them, the coupon summary, or checkout.

  function findTargets() {
    var items = document.querySelectorAll('.announcement-bar__item-inner');
    if (items.length > 0) {
      targets = Array.prototype.slice.call(items);
      return;
    }
    var slides = document.querySelectorAll('.announcement-bar__item');
    if (slides.length > 0) {
      targets = Array.prototype.slice.call(slides);
    }
  }

  function render(state) {
    if (targets.length === 0 || !state) return;

    var html;

    if (state.status === 'pending') {
      // A coupon quote is in flight — neutral note, no stale claim to flash.
      html = '<span class="hpq-ann__text">Checking shipping…</span>';
    } else if (state.status === 'empty') {
      html = '<span class="hpq-ann__text">FREE SHIPPING ON ORDERS ' + THRESHOLD_DOLLARS + '+</span>';
    } else if (state.status === 'free') {
      html = '<span class="hpq-ann__earned">✓ FREE SHIPPING EARNED</span>';
    } else {
      html = '<span class="hpq-ann__progress">'
        + '<span class="hpq-ann__track"><span class="hpq-ann__fill" style="width:' + state.pct + '%"></span></span>'
        + '<span class="hpq-ann__remain">' + fmt(state.remainingCents) + ' to FREE SHIPPING</span>'
        + '</span>';
    }

    targets.forEach(function (el) {
      el.innerHTML = html;
    });
  }

  function fmt(cents) {
    var d = Math.floor(cents / 100);
    var r = cents % 100;
    return '$' + d + '.' + String(r).padStart(2, '0');
  }

  function boot() {
    findTargets();
    // Render immediately only if the shared store already knows the cart (e.g. client-side
    // nav); otherwise wait for its first hpq:cart-changed so we don't flash a guess over
    // the server-rendered announcement text. Prefer the ViewModel; fall back to the legacy
    // window.hpqFreeShip state for load-order safety if the store isn't ready yet.
    if (window.hpqCartState && typeof window.hpqCartState.getVM === 'function') {
      var vm = window.hpqCartState.getVM();
      if (vm.rawItemCount !== null) render(vm.freeShip);
      return;
    }
    var fs = window.hpqFreeShip;
    if (fs) { var s = fs.getState(); if (s.itemCount !== null) render(s); }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Single source: every cart change, coupon quote, and pending transition arrives here as one
  // event carrying the shared ViewModel — read its freeShip sub-object.
  document.addEventListener('hpq:cart-changed', function (e) { render(e.detail && e.detail.freeShip); });
})();
